import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Project } from '../state-man/models/project.model';
import { LoggerService } from './logger.service';
import { UiService } from './ui.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  public async getMine () : Promise<Project[] | null> {   
    try {      
      const ret = await this.apiService.apiReturnsAny('get', 'projects/mine/')
      const projects = (ret && Array.isArray(ret)) ? Project.buildMany(ret) : null

      if (!projects) return null
      return projects      
    } catch (error) {
      LoggerService.log(error + 'projects/mine/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }  
}
